import { requestWrapper } from 'e-submission/domain/data'
import { getToggles } from 'quick-quote/feature-toggles'

export const onVerifyOCR = (user, payload) => {
  // {
  //   statusCode: response?.status,
  //   accountName: account_name,
  //   accountNumber: account_number,
  //   bankCode: bank_code,
  //   bankNameTH: bank_name_th,
  // }

  try {
    // return requestWrapper.postRequest(`ocr/verify`, user, payload).then(({ data }) => data)
    return {
      statusCode: 200,
      bankNameTH: 'ธนาคารกรุงศรีอยุธยา',
      accountName: 'นางสาว สุธิดา รัตตสัมพันธ์',
      accountNumber: '0041111111',
    }
  } catch (error) {
    return {
      statusCode: 500,
      bankNameTH: 'ธนาคารกรุงศรีอยุธยา',
      accountName: 'นางสาว สุธิดา รัตตสัมพันธ์',
      accountNumber: '0041111111',
    }
  }
}
